import {
  Popover,
  PopoverContent,
  PopoverHandler,
  Typography
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/InternationalAcademy/logo.png";
import paths from "../../routes/paths";
import PopoverMenu from "./menu_popover";


const Header = () => {
  const [scrolling, setScrolling] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > 0) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="text-slate-700 fixed transition-all top-0 bg-purple-400/80   z-50  fontstyle2  mx-auto flex flex-col w-screen overflow-hidden px-14 py-4 lg:flex-row lg:items-center">
      <Link to={paths.home}>
        <img
          src={logo}
          className={`w-32 ${scrolling ? "scale-100" : "scale-125"
            }  transition-all duration-300 `}
          alt=""
        />
      </Link>
      <input type="checkbox" className="peer hidden" id="navbar-open" />
      <label
        className="absolute top-5 right-5 cursor-pointer lg:hidden"
        htmlFor="navbar-open"
      >
        <svg
          className="h-7 w-7"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M4 6h16M4 12h16M4 18h16"
          ></path>
        </svg>
      </label>
      <nav
        aria-label="Header Navigation"
        className="peer-checked:pt-8 peer-checked:max-h-60 flex max-h-0 w-full flex-col items-center overflow-hidden transition-all lg:ml-24 lg:max-h-full lg:flex-row"
      >
        <hr className="mt-4 w-full lg:hidden" />
        <div className="my-4 flex items-center space-x-6 space-y-2 lg:my-0 lg:ml-auto lg:space-x-8 lg:space-y-0">
          <ul className="flex w-full text-white flex-col items-center space-y-1 lg:flex-row lg:justify-center lg:space-y-0">
            <li className="cursor-pointer lg:mr-12">
              {/* <Link to={paths.about}>
                <ProfileInfoPopover />
              </Link> */}
              <PopoverMenu title="About Us" menus={[
                { name: "Vision", link: `${paths.about}#vision` },
                { name: "Mission", link: `${paths.about}#mission` },
                { name: "Core Values", link: `${paths.about}#core` }
              ]} />
            </li>
            <li className="cursor-pointer lg:mr-12">
              {/* <Link to={paths.portfolio}>Our School</Link> */}
              <PopoverMenu title="Our School" menus={[
                { name: "Vision", link: `${paths.portfolio}#vision` },
                { name: "Mission", link: `${paths.portfolio}#mission` },
                { name: "Core Values", link: `${paths.portfolio}#core` },
                { name: "Founder", link: `${paths.portfolio}#founder` },
                { name: "Educational Philosophy", link: `${paths.portfolio}#education` },
                { name: "Academic Programs", link: `${paths.portfolio}#academic` },
                { name: "Campus and Facilities", link: `${paths.portfolio}#campus` },
                { name: "Global Exposure", link: `${paths.portfolio}#global` },
                { name: "Community Engagement", link: `${paths.portfolio}#community` },
                //Global Exposure
              ]} />
            </li>
            <li className="cursor-pointer lg:mr-12">
              <a href="#contact">Contact Us</a>
            </li>
            <li className="cursor-pointer lg:mr-12">
              <Link to="#blog">FAQ</Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Header;
